// extracted by mini-css-extract-plugin
module.exports = {"settingsWrapper":"_11dKqlQCT08aqNSzq7eSgc","sectionWrapper":"p2XW2R-fVzgQeMplYdnKr","settingsTitle":"_3DqSGuStO7L0FPrgE4kbJA"};